<template>
  <div class="maindiv1">
    <div data-v-12e95590="" class="loginhead"><h1 data-v-12e95590=""></h1></div>
    <div style="padding: 0% 10%;height: 100%">
      <el-tabs v-model="activeName" type="border-card"  style="width: 80%;margin: auto;">
        <el-tab-pane label="建设单位注册" name="5">            <!-- eui -->
        </el-tab-pane>
        <el-tab-pane label="测绘机构注册" name="2">            <!-- eui -->
        </el-tab-pane>
        <el-tab-pane label="设计单位注册" name="4">            <!-- eui -->
        </el-tab-pane>

        <div class="tip ewb-clearfix" style="text-align: left;" v-show="active===0">
          <p class="first-tip">
            <i><img src="../../../assets/icon03.png"></i>&nbsp;&nbsp;&nbsp;&nbsp;请如实填写信息 带 * 为必填项
          </p>
          <p v-if="activeName ==='2'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;中介机构操作步骤：1-登记注册；2-资质证书信息维护；3-服务事项信息维护；4-人员维护；5-主管部门审核；6-事项办理</p>
          <p v-if="activeName ==='4'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;中介机构操作步骤：1-登记注册；2-事项办理</p>
        </div>
        <br/>

        <el-form ref="elForm" :model="formData" :rules="rules" size="medium" label-position="right">
          <fieldset style="border-width: 1px;border-color: floralwhite;margin: 2.5%" v-show="active===0">
            <legend style="color: red;font-size: 16px;"><strong>账号信息</strong></legend>
            <br/>
            <el-col :span="20">
              <el-form-item label="统一社会信用代码" prop="jgdm" label-width="50%">
                <el-input v-model="formData.jgdm" placeholder="统一社会信用代码" clearable
                          :style="{width: '90%',}"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="20">
              <el-form-item label="单位名称" prop="dwmc" label-width="50%">
                <el-input v-model="formData.dwmc" autocomplete="off" placeholder="请输入单位名称" clearable
                          :style="{width: '90%'}"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="20">
              <el-form-item label="密码" prop="mm" label-width="50%">
                <el-input v-model="formData.mm" autocomplete="off" placeholder="请输入密码" clearable show-password
                          :style="{width: '90%'}">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="20">
              <el-form-item label="确认密码" prop="qrmm" label-width="50%">
                <el-input v-model="formData.qrmm" placeholder="请输入确认密码" clearable show-password
                          :style="{width: '90%'}">
                </el-input>
              </el-form-item>
            </el-col>
          </fieldset>
          <fieldset style="border-width: 1px;border-color: floralwhite;margin: 2.5%" v-show="active===0">
            <legend style="color: red;font-size: 16px;"><strong>基础信息</strong></legend>
            <br/>
            <el-col :span="11">
              <el-form-item label-width="120px" label="单位性质" prop="dwxz">
                <!--  <el-input v-model="formData.dwxz" placeholder="请输入单位性质" clearable :style="{width: '90%'}"  maxlength="100">
                  </el-input>-->
                <el-select class="item-choose" v-model="formData.dwxz" clearable :style="{width: '90%'}"
                           maxlength="100">
                  <el-option
                    v-for="(item,index) in dwxzlist"
                    :key="index"
                    :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <!--<el-col :span="11">
              <el-form-item label-width="120px" label="成立时间" prop="clsj">
                <el-date-picker v-model="formData.clsj" format="yyyy-MM-dd"
                                :style="{width: '90%'}" placeholder="请输入成立时间" clearable
                                :picker-options="start_Date"
                ></el-date-picker>
              </el-form-item>
            </el-col>-->

            <el-col :span="11">
              <el-form-item label-width="120px" label="法人代表" prop="frdb">
                <el-input v-model="formData.frdb" placeholder="请输入法人代表" maxlength="100" clearable
                          :style="{width: '90%'}">
                </el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="11">
               <el-form-item label-width="120px" label="营业执照编号" prop="yyzzbh">
                 <el-input v-model="formData.yyzzbh" placeholder="请输入营业执照编号" maxlength="50" clearable
                           :style="{width: '90%'}">
                 </el-input>
               </el-form-item>
             </el-col>
             <el-col :span="11"  v-if="activeName ==='3'">
               <el-form-item label-width="120px" label="营业执照有效期" prop="yyzzyxq">
                 <el-date-picker v-model="formData.yyzzyxq" format="yyyy-MM-dd"
                                 :style="{width: '90%'}" placeholder="请输入营业执照有效期" clearable ></el-date-picker>
               </el-form-item>
             </el-col>
              <el-col :span="11">
               <el-form-item label-width="134px" label="注册资本（万元）" prop="zczb">
                 <el-input v-model="formData.zczb" placeholder="请输入注册资本（万元）" maxlength="50" type="number" clearable
                           :style="{width: '95%',marginLeft:'-15px'}">
                 </el-input>
               </el-form-item>
             </el-col>
            <el-col :span="11">
               <el-form-item label-width="120px" label="注册时间" prop="zcsj">
                 <el-date-picker v-model="formData.zcsj" format="yyyy-MM-dd"
                                 :style="{width: '90%'}" placeholder="请输入注册时间" clearable
                                 :picker-options="start_Date"
                 ></el-date-picker>
               </el-form-item>
             </el-col>
            <el-col :span="11" v-if="activeName ==='3'">
              <el-form-item label-width="120px" label="资质证书编号" prop="zzzsbh">
                <el-input v-model="formData.zzzsbh" placeholder="请输入资质证书编号" maxlength="50" clearable
                          :style="{width: '90%'}">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="11" v-if="activeName ==='3'">
              <el-form-item label-width="120px" label="资质证书有效期" prop="zzzsyxq">
                <el-date-picker v-model="formData.zzzsyxq" format="yyyy-MM-dd"
                                :style="{width: '90%'}" placeholder="请输入资质证书有效期"  clearable ></el-date-picker>
              </el-form-item>
            </el-col>-->
            <el-col :span="11">
              <el-form-item label-width="120px" label="联系人" prop="lxr">
                <el-input v-model="formData.lxr" placeholder="请输入联系人" maxlength="50" clearable
                          :style="{width: '90%'}">
                </el-input>
              </el-form-item>
            </el-col>
            <!--  <el-col :span="11">
               <el-form-item label-width="120px" label="联系人电话" prop="lxrdh">
                 <el-input v-model="formData.lxrdh" placeholder="请输入联系人电话" maxlength="15" clearable
                           :style="{width: '90%'}">
                 </el-input>
               </el-form-item>
             </el-col>

            <el-col :span="11">
               <el-form-item label-width="120px" label="联系人邮箱" prop="lxryx">
                 <el-input v-model="formData.lxryx" placeholder="请输入联系人邮箱" maxlength="40" clearable
                           :style="{width: '90%'}">
                 </el-input>
               </el-form-item>
             </el-col>
             <el-col :span="11">
               <el-form-item label-width="120px" label="联系人传真" prop="lxrcz">
                 <el-input v-model="formData.lxrcz" placeholder="请输入联系人传真" clearable :style="{width: '90%'}"
                           maxlength="50">
                 </el-input>
               </el-form-item>
             </el-col>-->
            <el-col :span="11">
              <el-form-item label-width="120px" label="联系人手机" prop="lxrsj">
                <el-input v-model="formData.lxrsj" placeholder="请输入联系人手机" maxlength="11" clearable
                          :style="{width: '60%'}">
                </el-input>
                  <el-button type="primary" :disabled="isSendMsg" @click="sendMsg">{{smgButName}}</el-button>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label-width="120px" label="短信验证码" prop="jym">
                <el-input v-model="jym" placeholder="请输入短信验证码" maxlength="11" clearable
                          :style="{width: '90%'}">
                </el-input>
              </el-form-item>
            </el-col>

            <!--<el-col :span="22">
              <el-form-item label-width="120px" label="经营范围" prop="jyfw">
                <el-input v-model="formData.jyfw" type="textarea" placeholder="请输入经营范围"
                          :autosize="{minRows: 5, maxRows: 5}" :style="{width: '95%'}" maxlength="2000"></el-input>
              </el-form-item>
            </el-col>-->
            <el-col :span="12">
              <el-form-item label-width="120px" label="营业执照" prop="yyzzlj" align="left">
                <el-upload
                  :file-list="yyzzfileList"
                  :action="uploadAction"
                  :on-remove="yyzzOnRemove"
                  :on-preview="lookFile"
                  :before-upload="yyzzBeforeUpload"
                  :on-success="handleyyzzSuccess">
                  <el-button size="mini" type="primary" icon="el-icon-upload" style="height: 35px;">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip"></div>
                  <el-tooltip class="item" effect="light" content="商行政管理机关发给工商企业、个体经营者的准许从事某项生产经营活动的凭证。只能上传jpg/png文件，DPI高于200，且不超过1MB。" placement="right-start">
                    <i class="el-icon-question" />
                  </el-tooltip>
                </el-upload>
                <!---->
              </el-form-item>
            </el-col>
            <el-col :span="12"  v-if="activeName ==='4'">
              <el-form-item label-width="120px" label="资质证书" prop="zzzslj" align="left">
                <el-upload
                  :file-list="zzzsfileList"
                  :action="uploadAction"
                  :on-remove="zzzsOnRemove"
                  :on-preview="lookFile"
                  :before-upload="zzzsBeforeUpload"
                  :on-success="handlezzzsSuccess">
                  <el-button size="mini" type="primary" icon="el-icon-upload" style="height: 35px;">点击上传</el-button>
                  <el-tooltip class="item" effect="light" content="本单位符合相关行业规定，证明自身生产等能力的相关文件、证件,只能上传jpg/png文件，DPI高于200，且不超过1MB。" placement="right-start">
                    <i class="el-icon-question" />
                  </el-tooltip>
                </el-upload>
              </el-form-item>
            </el-col>
          </fieldset>
          <fieldset style="border-width: 1px;border-color: floralwhite;margin: 2.5%;height:300px;" v-show="active===1">
            <legend style="color: red;font-size: 16px;"><strong>绑定公众号</strong></legend>
            <br/>

            <el-col :span="11">
              <el-form-item label-width="120px" label="请关注公众号" >
                <img src="../../../assets/gzh.jpg" style="float: left;">
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label-width="160px" label="微信绑定公众号" >
                <el-button type="primary" style="float: left;" @click="vaildFun">绑定</el-button>
              </el-form-item>
            </el-col>
          </fieldset>
          <el-steps :active="active" finish-status="success" simple style="margin-top: 20px">
            <el-step title="填写账号信息、基础信息" icon="el-icon-document"></el-step>
            <el-step title="绑定公众号" icon="el-icon-success"></el-step>
          </el-steps>
          <div style="padding-top: 2%">
            <span slot="footer" class="dialog-footer" style="text-align: center; height: 30px">
                <div style="text-align: center">
                    <el-button v-show="active===0"  @click="next" type="primary" style="width: 250px;" >下一步</el-button>
              </div>
        </span>
          </div>

          <div class="form-item agreement-item " style="margin-left: 83px" v-show="active===1">
            <label class="agreement"> <input type="checkbox" id="agreement" name="agreement">我已阅读并同意
              <a id="certinfo" style="text-decoration: none" href="./static/certificationinfo.html"
                 target="_blank"><span style="color: blue;">《中介服务大厅管理办法》</span></a>,
              <a id="certinfo2" style="text-decoration: none" href="./static/certificationinfo2.html" target="_blank"><span
                style="color: blue;">《考核办法,成果标准文件说明》</span></a>
            </label>
          </div>
          <el-form-item size="large" v-show="active===1">
            <el-button v-show="active!==0" @click="goBack" style="width: 250px;">上一步</el-button>
            <el-button type="primary" @click="checkSmgCode" class="register-now" style="width: 250px;display:inline;margin-left: 5px;">立即注册</el-button>
            <!-- <el-button @click="resetForm">返回登录页</el-button>-->
          </el-form-item>
          <p class="login-now" v-show="active===1">
            已有账号？<a @click="resetForm" href="" style="color: rgb(64, 158, 255)">立即登录</a>
          </p>
          <br/>
        </el-form>
      </el-tabs>
    </div>
    <!--    <Footer></Footer>-->
    <!--图片查看-->
    <el-dialog :title="picTitle" width="80%" :visible.sync="showPictureVisible" top="5vh" center append-to-body>
      <div :style="viewerHeight">
        <viewer :options="options" :images="images"
                @inited="inited"
                class="viewer" ref="viewerr"
        >
          <template slot-scope="scope">
            <figure class="images">
              <div class="image-wrapper" v-for="{source, thumbnail,name} in scope.images" :key="source">
                <img class="image"
                     :src="thumbnail" :data-source="source" :alt="name"
                >
              </div>
            </figure>
          </template>
        </viewer>
      </div>
    </el-dialog>
    <!--pdf查看-->
    <el-dialog :title="pdfTitle" width="80%" :visible.sync="showPdfVisible" top="5vh" center append-to-body>
      <iframe :src="pdfSrc" width="100%" :height="iframeHeight"></iframe>
    </el-dialog>

    <el-dialog
        :visible.sync="vaildDialogVisible"
        :close-on-click-modal="false"
        style="overflow: hidden; margin: 0;"
        append-to-body
        :show-close="false"
        width="250px"
        close-on-press-escape
        @close="vaildHandleClose">
           <img :src="wxSrc"  style="text-align: center;margin-top: -35px;padding-left: 4px;"/>
           <div style="text-align: center;margin-top: 15px;margin-bottom: -10px;">
              <el-button  size="mini"  @click="vaildHandleClose">关闭</el-button>
           </div>
    </el-dialog>

    <el-dialog
      :visible.sync="jglxDialogVisible"
      :close-on-click-modal="false"
      style="overflow: hidden; margin: 0;"
      append-to-body
      :show-close="false"
      width="20%"
      top="32vh"
      close-on-press-escape
      @close="jglxHandleClose">
      <div style="height: 80px">
        <span style="float: left;margin-top: -30px;font-weight: bold;padding-left: 10px;margin-bottom: 20px">请选择机构注册类型:</span>
        <el-radio-group v-model="activeName" style="padding-left: 20px">
          <el-radio label="5">建设单位</el-radio>
          <el-radio label="2">测绘机构</el-radio>
          <el-radio label="4">设计单位</el-radio>
        </el-radio-group>
        <div style="text-align: center;margin-top: 30px">
          <el-button  size="mini" type="primary" @click="checkJglx">确定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import $ from 'jquery'
import Footer from '../main/Footer.vue'
import {BASE_URL, FIEL_UPLOAD, FIEL_DOWNLOAD,WECHAT_CALL_URL} from '../../../api/url'
import Cookie from 'cookies-js'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
import Vue from 'vue'

Vue.use(Viewer)
export default {
  components: {Footer},
  props: [],
  name: 'UserRegister',
  data () {
    return {
      pdfTitle: '',
      picTitle: '',
      pdfSrc: '',
      wxSrc: '',
      qrCode: '',
      active: 0,
      showPdfVisible: false,
      jglxDialogVisible: false,
      vaildDialogVisible: false,
      images: [],
      showPictureVisible: false,
      viewerr: '',
      iframeHeight: window.innerHeight - 195 + 'px',
      viewerHeight: {height: window.innerHeight - 195 + 'px'},
      options: {
        inline: true,
        button: true,
        navbar: true,
        title: true,
        toolbar: true,
        tooltip: true,
        movable: true,
        zoomable: true,
        rotatable: true,
        scalable: true,
        transition: true,
        fullscreen: true,
        keyboard: true,
        url: 'data-source'
      },
      uploadAction: FIEL_UPLOAD,
      yyzzfileList: [], // 营业执照附件
      zzzsfileList: [], // 资质证书附件
      dwxzlist: [
        {
          value: '企业',
          label: '企业'
        }, {
          value: '个体工商户',
          label: '个体工商户'
        }, {
          value: '社会团体',
          label: '社会团体'
        }, {
          value: '事业单位',
          label: '事业单位'
        }],
      start_Date: { // 时间限制
        disabledDate: time => {
          return time.getTime() > Date.now()
        }
      },
      jym: '',
      isSendMsg: false,
      smgButName: '发送短信',
      formData: {
        lybz: '外网注册',
        mm: '',
        qrmm: '',
        slzt: '0',
        dwmc: '',
        jgdm: '',
        jglb: '2',
        dwxz: '',
        clsj: '',
        frdb: '',
        yyzzbh: '',
        zczb: '',
        zcsj: '',
        lxr: '',
        lxrsj: '',
        lxrdh: '',
        lxryx: '',
        lxrcz: '',
        jyfw: '',
        yyzzlj: '',
        zzzsbh: '',
        zzzsyxq: '',
        yyzzyxq: '',
        zzzslj: ''
      },
      activeName: '',
      urerformData: {
        jgdm: '',
        dwmc: '',
        mm: '',
        qrmm: '',
        jglx: '1'
      },
      rules: {
        jgdm: [{
          required: true,
          message: '请输入机构代码',
          trigger: 'blur'
        }, {
          required: true,
          message: '请输入',
          trigger: 'blur'
        }],
        dwmc: [{
          required: true,
          message: '请输入单位名称',
          trigger: 'blur'
        }],
        mm: [{
          required: true,
          pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,18}$/,
          message: '密码需包含数字、字母两种元素，且密码位数为6-16位',
          trigger: 'blur'
        }],
        qrmm: [{
          required: true,
          message: '请输入确认密码',
          trigger: 'blur'
        }],
        dwmc: [{
          required: true,
          message: '请输入单位名称',
          trigger: 'blur'
        }],
        dwxz: [{
          required: true,
          message: '请输入单位性质',
          trigger: 'blur'
        }],
        clsj: [{
          required: true,
          message: '请输入成立时间',
          trigger: 'change'
        }],
        frdb: [{
          required: true,
          message: '请输入法人代表',
          trigger: 'blur'
        }],
        yyzzbh: [{
          required: true,
          message: '请输入营业执照编号',
          trigger: 'blur'
        }],
        zczb: [{
          required: true,
          message: '请输入注册资本（万元）',
          trigger: 'blur'
        }],
        zcsj: [{
          required: true,
          message: '请输入注册时间',
          trigger: 'change'
        }],
        lxr: [{
          required: true,
          message: '请输入联系人',
          trigger: 'blur'
        }],
        lxrsj: [{
          required: true,
          message: '请输入正确的联系人手机',
          pattern: /^((1[3,5,8,7,9][0-9])|(14[5,7])|(17[0,6,7,8])|(19[7]))\d{8}$/,
          trigger: 'blur'
        }],
        lxrdh: [{
          required: true,
          message: '请输入联系人电话',
          trigger: 'blur'
        }],
        jyfw: [{
          required: true,
          message: '请输入经营范围',
          trigger: 'blur'
        }],
        yyzzlj: [{
          required: true,
          message: '请上传营业执照',
          trigger: 'blur'
        }],
        yyzzyxq: [{
          required: true,
          message: '请输入营业执照有效期',
          trigger: 'blur'
        }],
        zzzsbh: [{
          required: true,
          message: '请输入资质证书编号',
          trigger: 'blur'
        }],
        zzzsyxq: [{
          required: true,
          message: '请输入资质证书有效期',
          trigger: 'blur'
        }],
        zzzslj: [{
          required: true,
          message: '请上传资质证书',
          trigger: 'blur'
        }]
      }
    }
  },
  methods: {
    inited (viewer) {
      this.viewerr = viewer
    },
    vaildFun() {
        let self = this;
        var phone = self.formData.lxrsj
        var jgdm = self.formData.jgdm
        if (jgdm===undefined || jgdm==="") {
            self.$message.warning("统一社会信用代码不能为空！");
            return false
        }
        if (phone===undefined || phone==="") {
            self.$message.warning("联系人手机不能为空！");
            return false
        }
        if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(phone))) {
            self.$message.error('手机号码规则不正确，请重新填写!')
            return false
        }
        var param = [];
        //param.push("http://192.165.122.223:21907/wechat/WeChatProvider/getOauth");
        param.push(WECHAT_CALL_URL);
        param.push(phone+","+jgdm);
        $.ajax({
            type: 'POST',
            url: BASE_URL,
            data: {
                interfaceName: 'antu.dchyww.provider.wechat.WeChatProvider',
                methodName: 'getBindQRCode',
                args: param
            },
            success: function (data) {
                if (data.status == 0) {
                    self.vaildDialogVisible = true;
                    let result = JSON.parse(data.result);
                    self.wxSrc = "data:image/png;base64,"+result.qrCode;
                } else {
                    self.$message.error(data.message)
                }
            },
            error: function () {
                self.$message.error('无法连接服务器！请检查网络')
            }
        })
        //window.open(url);
    },
    vaildHandleClose() {
        this.vaildDialogVisible = false;
    },
    jglxHandleClose(){
        this.jglxDialogVisible=false;
    },
    checkJglx(){
        if (this.activeName===undefined || this.activeName==="" || this.activeName==="0") {
            this.$message.warning("请选择机构类型！")
            return;
        }else {
            this.jglxDialogVisible=false;
        }
    },
    lookFile (file) {
      let path = file.response.result
      let name = file.name
      let ext = name.substring(name.indexOf('.') + 1).toLowerCase()
      if (ext === 'pdf') {
        let url = FIEL_DOWNLOAD
        url += '?name=' + encodeURI(name)
        url += '&path=' + encodeURI(path)
        this.pdfSrc = './kjfx/pdf/web/viewer.html?file=' + encodeURIComponent(url)
        this.pdfTitle = name.substring(0, name.indexOf('.'))
        this.showPdfVisible = true
      } else if (ext === 'jpg' || ext === 'jpeg' || ext === 'png') {
        let url = FIEL_DOWNLOAD

        url += '?name=' + encodeURI(name)
        url += '&path=' + encodeURI(path)
        url += '&isOnLine=true'
        url = encodeURI(url)
        this.picTitle = name.substring(0, name.indexOf('.'))
        this.$set(this.images, 0, {source: url, thumbnail: url, name: name})
        this.showPictureVisible = true
      } else {
        this.$message.success('请下载后查看类型为：' + ext + '的文件！')
        let url = FIEL_DOWNLOAD
        url += '?name=' + encodeURI(name)
        url += '&path=' + encodeURI(path)
        window.open(url)
      }

      // window.open(encodeURI(url));
    },
    yyzzOnRemove () {
      this.formData.yyzzlj = ''
    },
    zzzsOnRemove () {
      this.formData.zzzslj = ''
    },
    yyzzBeforeUpload (file) {
      if (this.formData.yyzzlj !== '') {
        this.$message.error('营业执照为单文件上传！')
        return false
      }
      /*  var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1);
              if (testmsg !== 'png'&& testmsg!=='jpg'&& testmsg !== 'jpeg' &&testmsg!=='bmp') {
                this.$message.error('请上传符合要求的格式图形文件!如：png,jpg,jpeg,bmp');
                return false
              } */
      let isRightSize = file.size / 1024 / 1024 <= 1
      if (!isRightSize) {
        // this.$message.error('照片大小超过 1MB,请压缩后重新上传!');
        this.$alert('照片大小超过 1MB,请压缩后重新上传!', '系统提示', {
          callback: () => {
            window.open('https://www.yasuotu.com')
          }
        })
      }
      return isRightSize
    },
    zzzsBeforeUpload (file) {
      if (this.formData.zzzslj !== '') {
        this.$message.error('资质证书为单文件上传！')
        return false
      }
      let isRightSize = file.size / 1024 / 1024 <= 1
      if (!isRightSize) {
        // this.$message.error('照片大小超过 1MB,请压缩后重新上传!');
        this.$alert('照片大小超过 1MB,请压缩后重新上传!', '系统提示', {
          callback: () => {
            window.open('https://www.yasuotu.com')
          }
        })
      }
      return isRightSize
    },
    handleyyzzSuccess (res, file, List) {
      var status = res.status
      var self = this
      if (status == -1) {
        self.$message.error('上传失败!')
      } else {
        // 上传成功后降文件路径和文件名赋值给表单字段
        self.formData.yyzzlj = `{"path":"${res.result}","fileName":"${file.name}"}`
        self.$message.success('上传成功!')
      }
    },
    handlezzzsSuccess (res, file, List) {
      var status = res.status
      var self = this
      if (status == -1) {
        self.$message.error('上传失败!')
      } else {
        // 上传成功后降文件路径和文件名赋值给表单字段
        self.formData.zzzslj = `{"path":"${res.result}","fileName":"${file.name}"}`
        self.$message.success('上传成功!')
      }
    },
    checkSmgCode () {
      var self = this
      if (!self.jym) {
        self.$message.error('短信验证码错误!')
        return false
      }
      var parm = []
      parm.push('')
      parm.push('dchy')
      parm.push(self.formData.lxrsj)
      parm.push(self.jym)
      $.ajax({
        type: 'POST',
        url: BASE_URL,
        async: false,
        data: {
          interfaceName: 'antu.dchyww.provider.mobile.MobileSmgProvider',
          methodName: 'checkSmgCode',
          args: parm
        },
        success: function (data) {
          if (data.status == 0) {
            self.submitForm()
          } else {
            self.$message.error(data.message)
          }
        },
        error: function (jqXHR) {
          self.loading = false
          self.$message.error('无法连接服务器！请检查网络')
        }
      })
    },
    submitForm () {
      this.$refs['elForm'].validate(valid => {
        if (!valid) return
        var self = this
        var parm = []
        if (self.formData.mm !== self.formData.qrmm) {
          self.$message.error('俩次密码输入不一致！')
          return
        }
        if (!$('#agreement').is(':checked')) {
          self.$message.warning('请先阅读并同意协议！')
          return
        }
        parm.push(self.formData.jgdm)
        parm.push(self.formData.dwmc)
        parm.push(this.$md5(self.formData.mm))
        parm.push(self.formData.lxrsj)
        parm.push(self.activeName)
        // 基础信息赋值
        parm.push(JSON.stringify(self.formData))
        const loading = this.$loading({
          lock: true,
          text: '正在处理中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        $.ajax({
          type: 'POST',
          url: BASE_URL,
          data: {
            interfaceName: 'antu.dchyww.provider.login.UserLoginProvider',
            methodName: 'userRegister',
            args: parm
          },
          success: function (data) {
            loading.close()
            if (data.status == 0) {
              self.$message.success('注册成功！')
              self.$router.push('/')
            } else {
              self.$message.error(data.message)
            }
          },
          error: function (jqXHR) {
            loading.close()
            self.loading = false
            self.$message.error('无法连接服务器！请检查网络')
          }
        })
      })
    },
    resetForm () {
      this.$router.push('/')
    },
    // 发送短信操作
    sendMsg () {
      var self = this
      var phone = self.formData.lxrsj
      if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(phone))) {
        self.$message.error('手机号码规则不正确，请重新填写!')
        return false
      }
      var parm = []
      parm.push('')
      parm.push('dchy')
      parm.push(self.formData.lxrsj)
      parm.push('dchySms')
      parm.push('dwzcMsg')
      parm.push('注册')
      $.ajax({
        type: 'POST',
        url: BASE_URL,
        async: false,
        data: {
          interfaceName: 'antu.dchyww.provider.mobile.MobileSmgProvider',
          methodName: 'pushCode',
          args: parm
        },
        success: function (data) {
          if (data.status == 0) {
            var res = data.result;
            var count = parseInt(res);
            if (count>=3) {
                self.$message.warning('手机号码：'+phone+'在当天已经发送短信'+count+'次，请慎重发送，当天最多发送5次！');
            }
            self.isSendMsg = true
            var i = 60
            var countdown = setInterval(function () {
              i--
              self.smgButName = '(' + i + ')秒后重试'
              if (i <= 0) {
                clearInterval(countdown)
                self.smgButName = '发送短信'
                self.isSendMsg = false
              }
            }, 1000)
          }
        },
        error: function (jqXHR) {
          loading.close()
          self.loading = false
          self.$message.error('无法连接服务器！请检查网络')
        }
      })
    },
    selectJglx () {
      //this.$message.info('请选择注册类型!')
       this.jglxDialogVisible=true;
    },
    goBack(){
        if (this.active===1){
            this.active--;
        }
    },
    next() {
        var self = this;
        self.$refs['elForm'].validate(valid => {
            if (!valid) return
            var parm = []
            if (self.formData.mm !== self.formData.qrmm) {
                self.$message.error('俩次密码输入不一致！')
                return
            }
            if (self.jym=="") {
                self.$message.error('请输入短信验证码！')
                return
            }
            if (self.active ===0){
                this.active++;
            }
        })
    },
  },
  mounted () {
    this.selectJglx()
  },
  created () {
  }
}
</script>

<style scoped>
  .maindiv1 {
    background-image: url('../../../assets/bj3.png');
    background-size: 100% 70%;
    margin: 1px;
    padding: 1px;

  }

  .tip {
    width: 880px;
    margin: 22px auto 30px;
    color: #ff0000;
    line-height: 19px;
  }

  .register-now {
    display: block;
    width: 500px;
    height: 40px;
    margin: 40px auto 20px;
    margin-top: 40px;
    background-color: rgb(64, 158, 255);
    color: #fff;
    font-size: 16px;
    font-family: 'Microsoft Yahei';
    font-weight: bold;
    letter-spacing: 3px;
    border: none;
    border-radius: 3px;
    cursor: pointer;
    transition: 0.5s all;
  }

  .login-now {
    text-align: center;
  }

  .loginhead {
    height: 45px;
    width: 800px;
    margin: 3% auto;
    background-image: url('../../../assets/toplogo.png');
    background-size: 100% 100%;
    padding-top: 100px;
  }

  /deep/ .el-input--medium .el-input__inner {
    height: 40px !important;
  }

  .viewer {
    height: 100%;
  }

  .images {
    height: 100%;
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
    flex-wrap: wrap;
    padding: 5px;
  }

  .image-wrapper {
    display: inline-block;
    width: calc(33% - 20px);
    margin: 5px 5px 0 5px;
  }

  .image {
    width: 100%;
    cursor: pointer;
    display: inline-block;
  }
  /deep/ .el-icon-question:before {
    color: #409EFF !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/kjfx/login/UserRegister.vue